module.exports = __webpack_public_path__ + "img/bybit.a91dc68d.svg";